import { render, staticRenderFns } from "./buttonIcon-editor.vue?vue&type=template&id=1b57230c&scoped=true&"
import script from "./buttonIcon-editor.vue?vue&type=script&lang=js&"
export * from "./buttonIcon-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b57230c",
  null
  
)

export default component.exports